var React = require('react');

function BeigeAries (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.5054,4.8015c-1.4115,0-2.5556,1.1441-2.5556,2.5556s1.1441,2.5556,2.5556,2.5556h.8522v3.4087h-.8522c-3.2936,0-5.9634-2.6708-5.9634-5.9643S3.2119,1.3937,6.5054,1.3937c1.9519,0,3.6861.941,4.7713,2.3852,1.174,1.5656,2.1495,3.4586,2.8965,6.0423.7461-2.5837,1.7225-4.4776,2.8965-6.0432,1.0852-1.4442,2.8185-2.3843,4.7704-2.3843,3.2945,0,5.9643,2.6699,5.9643,5.9634s-2.6699,5.9643-5.9643,5.9643h-.8513v-3.4087h.8513c1.4115,0,2.5565-1.1441,2.5565-2.5556s-1.145-2.5556-2.5565-2.5556c-.834,0-1.5747.398-2.0443,1.0226-2.2012,2.9346-3.9137,7.8346-3.9191,21.0688v.0598h-3.4078v-.058c-.0045-13.2351-1.717-18.136-3.9182-21.0706-.4696-.6246-1.2103-1.0226-2.0452-1.0226h0Z","fill":"#734f3e","strokeWidth":"0"}));
}

BeigeAries.defaultProps = {"id":"Layer_1","data-name":"Layer 1","version":"1.1","viewBox":"0 0 28.3465 28.3465"};

module.exports = BeigeAries;

BeigeAries.default = BeigeAries;
